import VetQuestApi from "./VetQuestApi";
import { ResponseModel, IEmailSentModel, IEmailViewModel } from "@/models";

export abstract class EmailService {
  static BASE: string = "email";
  static async SendEmailToFriend(
    model: IEmailViewModel
  ): Promise<ResponseModel<IEmailSentModel>> {
    let response = new ResponseModel<IEmailSentModel>(0, {} as IEmailSentModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE}/send`,
        model
      );
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }

  static async ReplyEmailToFriend(
    model: IEmailViewModel
  ): Promise<ResponseModel<IEmailSentModel>> {
    let response = new ResponseModel<IEmailSentModel>(0, {} as IEmailSentModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE}/reply`,
        model
      );
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }
}
